import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=ba31e45c&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=ba31e45c&prod&lang=less&scoped=true"
import style1 from "./transfer.vue?vue&type=style&index=1&id=ba31e45c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba31e45c",
  null
  
)

export default component.exports